export class DelegateParams {

    public constructor(public data: {[key: string]: any} = {}) {}

    public get<T = any>(param: string): T {
        return this.data[param];
    }
}
